import React from 'react';
// Constants
import { CompanyName } from '../../../utils/Constants';
// Components
import BookingAdminPageMainContainer from '../../../components/booking/admin/BookingAdminPageMainContainer';
import Navbar from '../../../components/nav/Navbar';
import { HelmetItem } from '../../../components/utils/HelmetItem';

function BookingAdminPage() {
  return (
    <>
      <HelmetItem
        PageName='Booking Admin'
        desc={`${CompanyName} — book commercials, UGC creation, or wellness coaching. Secure your spot today and get the help you need, tailored to your goals.`}
        keywords={`booking, schedule, commercials, UGC creator, wellness coaching, ${CompanyName}, Drammen Norway, worldwide`}
        additionalMeta={[]}
        structuredData={[]}
      />

      {/* Page */}
      <div className='grid min-h-screen overflow-hidden bg-colour1 text-colour2 dark:bg-colour2 dark:text-colour1 font-poppins'>
        {/* Navigation */}
        <Navbar />

        <div className='grid grid-rows-reg'>
          {/* Header */}
          <header
            className='grid w-full pt-[102px] lg:pt-[84px]'
            aria-labelledby='booking-page-title'
          >
            <div className='grid w-full px-2 md:px-4 lg:px-6 py-2 lg:container lg:mx-auto bg-colour5 text-colour1 text-center rounded-xl'>
              <article className='grid text-center sm:text-lg md:text-xl lg:text-2xl font-bold'>
                <h1>Booking Admin</h1>
              </article>
            </div>
          </header>

          {/* Main */}
          <BookingAdminPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default BookingAdminPage;
